import { motion, AnimatePresence } from "framer-motion";
import { PartyPopper, ArrowRight } from "lucide-react";

const LINES = ["La práctica de hoy queda hecha.", "Un paso pequeño cuenta.", "Puedes continuar a tu ritmo."];

export const Celebrate = ({ day, nextDay, onNext, onClose }) => (
  <AnimatePresence>
    {day && (
      <motion.div className="fixed inset-0 z-50 grid place-items-center bg-[var(--ink)]/50 backdrop-blur-sm px-5" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
        <motion.div data-testid="celebrate-modal" onClick={(e) => e.stopPropagation()}
          className="bg-[var(--cream)] rounded-lg p-8 max-w-sm w-full text-center border border-[var(--sand)] shadow-[0_18px_48px_rgba(52,56,50,0.16)]"
          initial={{ scale: 0.96 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 260, damping: 22 }}>
          <motion.div className="w-16 h-16 mx-auto rounded-full bg-[var(--sand)] grid place-items-center text-[var(--forest)]" animate={{ rotate: [0, -8, 8, 0] }} transition={{ duration: 0.8 }}>
            <PartyPopper />
          </motion.div>
          <p className="font-hand text-3xl text-[var(--terra)] mt-4">¡Día {day} hecho!</p>
          <p className="font-display text-2xl mt-1">{LINES[(day - 1) % LINES.length]}</p>
          {nextDay ? (
            <button data-testid="celebrate-next-button" onClick={onNext} className="btn-accent w-full mt-6">Ir al día {nextDay} <ArrowRight size={18} /></button>
          ) : (
            <p className="mt-6 font-semibold text-[var(--sage-deep)]">¡Has terminado el reto! Qué orgullo.</p>
          )}
          <button data-testid="celebrate-close-button" onClick={onClose} className="mt-3 text-sm underline">Quedarme aquí</button>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
